
const nameof = <T>(name: keyof T): string => name.toString();

export default nameof;
